import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import { FormProvider, useForm } from "react-hook-form";
import { makeStyles } from "@material-ui/styles";
import CloseIcon from "@material-ui/icons/Close";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";

const useStyles = makeStyles((theme) => ({
  dialogGeneral: {
    padding: "0px 10px 10px 10px",
    background: "#323940",
  },
  btnAceptar: {
    backgroundColor: "#4d90fe",
    color: "#000",
    "&:hover": {
      backgroundColor: "#357ae8",
    },
  },
  btnCancelar: {
    backgroundColor: "#4d90fe",
    color: "#000",
    "&:hover": {
      backgroundColor: "#357ae8",
    },
  },
  accionesIzquierda: {
    justifyContent: "flex-start",
  },
  dialogTitle: {
    backgroundColor: "#323940",
    color: "#CCCCCC",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontFamily: "Arial",
    fontSize: "18.0pt",
    fontWeight: "400",
    textTransform: "uppercase",
  },
  dialogContent: {
    backgroundColor: "#323940",
    color: "#fff",
  },
  dialogActions: {
    backgroundColor: "#323940",
  },
  closeButton: {
    color: "#fff",
  },
}));

const ModalFormulario = (props) => {
  const {
    open,
    titulo,
    OnCancelar,
    onCerrar,
    width,
    bloqueo,
    aceptar,
    children,
    mensajeConfirmacion,
    noActions,
  } = props;

  const classes = useStyles();
  const  classestablero = useStylesTablero();
  const methods = useForm();
  const [mAdvertencia, setMAdvertencia] = useState({ open: false, data: null });

  const cerrarAdvertencia = () => setMAdvertencia({ open: false, data: null });

  // Abre la advertencia solo si `mensajeConfirmacion` tiene valor
  const abrirAdvertencia = (data) => {
    if (mensajeConfirmacion) {
      setMAdvertencia({ open: true, data: data });
    } else {
      aceptar(data);
    }
  };

  // Envía los datos al confirmar la advertencia
  const confirmarEnvio = () => {
    if (mAdvertencia.data) {
      aceptar(mAdvertencia.data);
      cerrarAdvertencia();
    }
  };

  useEffect(() => {
    if (!open) {
      if (mAdvertencia.open) cerrarAdvertencia();
    } else {
      methods.reset();
    }
  }, [open]);

  return (
    <>
      {/* Modal principal */}
      <Dialog
        open={open}
        onClose={onCerrar}
        scroll="body"
        fullWidth
        maxWidth={width}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle disableTypography className={classes.dialogTitle}>
          <span>{titulo}</span>
          <IconButton
            title="cerrar"
            className={classes.closeButton}
            onClick={onCerrar}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <FormProvider {...methods}>
          <form
            autoComplete="off"
            onSubmit={methods.handleSubmit(abrirAdvertencia)}
          >
            <DialogContent className={classes.dialogContent}>
              {children}
            </DialogContent>
            <DialogActions
              className={`${classestablero.dialogActions}`}
            >
              {!noActions && (
                <>
                  <Button onClick={onCerrar} className={classestablero.btnCancelar}>
                    Cancelar
                  </Button>
                  {aceptar && (
                    <Button
                      type="submit" // Se usa submit para que maneje el formulario con react-hook-form
                      disabled={bloqueo}
                      className={classestablero.btnAceptar}
                    >
                      Confirmar
                    </Button>
                  )}
                </>
              )}
            </DialogActions>
          </form>
        </FormProvider>
      </Dialog>

      {/* Modal de Advertencia */}
      {mensajeConfirmacion && (
        <Dialog
          open={mAdvertencia.open}
          onClose={cerrarAdvertencia}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Advertencia</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {mensajeConfirmacion == true
                ? "Asegúrese de que todos los campos son correctos antes de continuar, ¿Está seguro de continuar?"
                : mensajeConfirmacion}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={cerrarAdvertencia} className={classes.btnCancelar}>
              Regresar
            </Button>
            <Button
              onClick={confirmarEnvio} // Confirma y envía los datos
              disabled={bloqueo}
              className={classes.btnAceptar}
            >
              Confirmar Envío
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

ModalFormulario.propTypes = {
  open: PropTypes.bool.isRequired,
  titulo: PropTypes.string.isRequired,
  OnCancelar: PropTypes.func.isRequired,
  children: PropTypes.node,
  aceptar: PropTypes.func.isRequired,
  width: PropTypes.string,
  bloqueo: PropTypes.bool,
  mensajeConfirmacion: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]), // Acepta string o booleano
};

ModalFormulario.defaultProps = {
  width: "md",
  bloqueo: false,
  mensajeConfirmacion: false,
};

export default ModalFormulario;
